import { render } from "./DOE.vue?vue&type=template&id=33248886&scoped=true&ts=true"
import script from "./DOE.vue?vue&type=script&lang=ts"
export * from "./DOE.vue?vue&type=script&lang=ts"

import "./DOE.vue?vue&type=style&index=0&id=33248886&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33248886"]])

export default __exports__